import { Type } from '@angular/core';

import { merge } from '../internals/merge';
import { OptionalsRequired } from '../types';
import { BaseSpecOptions, getDefaultBaseOptions } from '../base/options';
import { HostComponent } from '../Spec-host/host-component';

/**
 * @publicApi
 */
export interface SpecPipeOptions<P, H> extends BaseSpecOptions {
  pipe: Type<P>;
  host?: Type<H>;
  detectChanges?: boolean;
  template?: string;
}

const defaultSpecPipeOptions: OptionalsRequired<SpecPipeOptions<any, any>> = {
  ...getDefaultBaseOptions(),
  host: HostComponent,
  detectChanges: true,
  template: ''
};

/**
 * @internal
 */
export function getSpecPipeDefaultOptions<P, H>(overrides?: SpecPipeOptions<P, H>): Required<SpecPipeOptions<P, H>> {
  return merge(defaultSpecPipeOptions, overrides);
}
